import _DTO from "./_DTO";


export default class ConfigurationAccessoriesDTO extends _DTO {

  constructor(accessories) {
    super();
    this.softwareList = ConfigurationAccessoriesDTO.getMappedOrDefault(accessories, 'softwareList', [], data => data.map(d => d));
  }

}
